@import 'styles/variables';
@import 'styles/mixins';
@import 'styles/blaze/mixins';

.modalBody {
  width: 650px !important;

  @include for-phone-only {
    width: 100% !important;
  }
}

.headerTabs {
  display: flex;
  gap: 4px;
}

.headerTab {
  border-radius: 8px;
}

.headerTabSelected {
  background-color: #d9d9d9 !important;
  color: var(--dark-90) !important;
}

.tabContentArea {
  background-color: var(--light-80);
  border-radius: 0 0 20px 20px;
  padding: 0 40px;
  overflow: hidden;
}

.googleContactsHeader {
  display: flex;
  align-items: center;
  gap: 8px;
}

.buttonText {
  margin-left: 6px;
}

.inputHeader,
.shareLinkHeader {
  @include md-sohne-medium;
  color: var(--dark-80);
  line-height: 120%;
}

.dividerContainer {
  align-items: center;
  display: flex;
  padding: 40px 0;

  p {
    @include md-medium;
    color: var(--neutral-30);
    margin: 0 16px;
  }

  .divider {
    background-color: var(--neutral-10);
    height: 1px;
    flex: 1;
  }
}

.subtext {
  @include md-regular;

  color: var(--neutral-50);
  font-weight: 400;

  .bold {
    font-weight: 700;
  }
}

.labelContainer {
  margin-bottom: 12px;

  @include for-tablet-portrait-up {
    display: flex;
    justify-content: space-between;
    padding: 0 64px;
  }

  @include for-phone-only {
    display: flex;
    padding: 0 16px;
    flex-direction: column;
    align-items: center;
  }

  p {
    margin: 0;
  }
}

.mobileEmailInput {
  min-height: 156px;
}

.inviteButtonContainer {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.inviteButtonTooltipContainer {
  width: 100%;

  button {
    width: 100%;
  }
}

.inputContainer {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.emailInputContainer,
.shareLinkContainer {
  display: flex;
  flex-direction: column;
  gap: 10px;

  @include for-phone-only {
    gap: 12px;
  }
}

.messageInputContainer {
  gap: 10px;
  display: flex;
  flex-direction: column;
  padding-bottom: 15px;

  @include for-phone-only {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
}

.userRow {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 6px 8px 6px 4px;
  cursor: pointer;
  min-height: 57px;

  &:hover {
    background: $grey-5;
  }

  .userData {
    align-items: center;
    display: flex;
    gap: 12px;

    .contactInfo {
      max-width: 364px;
    }

    .name {
      @include lg-regular;

      color: $grey-90;
    }

    .email {
      @include md-regular;

      color: $grey-40;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      @include for-phone-only {
        max-width: 250px;
      }
    }
  }

  :global .ant-checkbox-wrapper {
    @include for-phone-only {
      // so it's not on top os sticky header
      z-index: -1;
    }
  }

  :global .ant-checkbox-inner {
    border-color: $gray-30 !important;
    border-radius: 4px;
    width: 20px;
    height: 20px;
  }

  :global .ant-checkbox-checked {
    &::after {
      border-color: $blue-50 !important;
    }
    .ant-checkbox-inner {
      background-color: $blue-10 !important;
      border-color: $blue-50 !important;

      &::after {
        border-color: $blue-50 !important;

        position: absolute;
        left: 5.5px;
        right: 5.5px;
        top: 8px;
        bottom: 8px;
      }
    }
  }
}

.userRow + .userRow {
  border-top: 1px solid $grey-10;
}

.checkMarkIcon {
  align-items: center;
  border: 1px solid $white;
  border-radius: 50%;
  display: flex;
  height: 15px;
  justify-content: space-evenly;
  width: 15px;
  margin-right: 5px;
}

.linkIcon,
.shareIcon {
  path {
    fill: $white;
  }
}

.inviteButton {
  height: 48px;
  width: 100%;
  gap: 12px;
}

.linkContainer {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.copyLinkContainer {
  display: flex;
  gap: 10px;
  justify-content: space-between;

  input {
    background: var(--light-100);
    border: 1px solid var(--dark-10);
    border-radius: 6px;
    padding: 8px 12px;
    width: 100%;
    height: 36px;
  }

  .linkButtonText {
    width: 62px;
  }
}

.pillsWrapper {
  :global {
    // Target pill divs rendered by ProseMirror inside the wrapper
    [class*='pill'] {
      background: var(--dark-3);
      border: 1px solid var(--dark-8);
      border-radius: 8px;
      padding: 3px 6px 4px 10px;
      margin-right: 6px;

      button {
        margin-left: 4px;
        border-radius: 4px;
        color: var(--dark-40);

        &:hover {
          color: var(--dark-60);
          background: var(--dark-5);
        }
      }
    }
  }
}

.emailAddressesListContainer {
  @include input-border;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  min-height: 40px;
  position: relative;
  overflow: hidden;

  [data-autopilot-system-redesign='on'] & {
    padding-top: 5px;
    height: 40px;

    > div {
      padding-top: 0;
    }
  }
}

.emailMessage {
  height: 129px;
  border-radius: 10px;

  textarea {
    @include md-sohne;
  }
}

.inviteByEmailFooter {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 15px;
  margin: 20px -40px 0;
  border-top: 1px solid var(--dark-4);

  @include for-phone-only {
    align-items: initial;
    flex-direction: column-reverse;
    gap: 10px;
    margin: 20px 0 0;
    padding: 16px 0;
  }
}

.inviteByLinkFooter {
  align-items: center;
  display: flex;
  justify-content: space-around;

  @include for-phone-only {
    align-items: initial;
    flex-direction: column;
  }
}

.mobileContentContainer {
  padding: 20px;
}

.inviteByEmailFooterRight {
  display: flex;
  align-items: center;
  gap: 8px;
}

.importSection {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-bottom: 20px;
}

.googleContactsButton {
  width: 275px;
}

.upgradeToGrowthButton {
  background: #6a00ff1a 10% !important;
  color: #6a00ff !important;
}

@media (max-width: $phoneMaxWidth) {
  .mobileContentContainer {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}
